/**
 * NiceAdmin-style surface overrides: white cards, rounded, subtle shadow.
 */
export const surfacesCustomizations = {
  MuiCard: {
    styleOverrides: {
      root: {
        boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
        borderRadius: 12,
        border: 'none',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
        borderRadius: 12,
      },
    },
  },
};
